import React from "react";
import {
  FaFileContract,
  FaShoppingCart,
  FaUserShield,
  FaBoxOpen,
  FaCreditCard,
  FaTruck,
  FaUndo,
  FaShieldAlt,
  FaBalanceScale,
  FaPhoneAlt,
} from "react-icons/fa";

const TermsConditions = () => {
  const sections = [
    {
      icon: <FaFileContract />,
      title: "Acceptance of Terms",
      content:
        "By accessing or using Glamira, you agree to comply with and be bound by these Terms & Conditions. If you do not agree with any part of these terms, please discontinue using our website and services.",
    },
    {
      icon: <FaShoppingCart />,
      title: "About Our Platform",
      content:
        "Glamira is an eCommerce platform that enables customers to browse, purchase, and receive products through a secure online shopping experience. We strive to provide accurate product information, transparent pricing, and reliable service.",
    },
    {
      icon: <FaUserShield />,
      title: "User Accounts",
      list: [
        "Users are responsible for maintaining the confidentiality of their account credentials.",
        "All information provided during registration must be accurate and up to date.",
        "Unauthorized use of your account should be reported immediately.",
      ],
    },
    {
      icon: <FaBoxOpen />,
      title: "Products & Availability",
      list: [
        "Product images are for illustration purposes and may vary slightly.",
        "Availability is subject to stock and may change without notice.",
        "We reserve the right to modify product details, pricing, or discontinue products at any time.",
      ],
    },
    {
      icon: <FaCreditCard />,
      title: "Pricing & Payments",
      list: [
        "All prices displayed are subject to applicable taxes unless otherwise specified.",
        "Orders are confirmed only after successful payment verification.",
        "In case of pricing or technical errors, Glamira reserves the right to cancel or modify orders.",
      ],
    },
    {
      icon: <FaTruck />,
      title: "Shipping & Delivery",
      list: [
        "Delivery timelines are estimates and may vary based on location and logistics partners.",
        "Customers must provide accurate shipping details.",
        "Delays due to weather, natural disasters, or unforeseen events are beyond our control.",
      ],
    },
    {
      icon: <FaUndo />,
      title: "Order Cancellation",
      content:
        "Orders can be cancelled before dispatch. Once shipped, cancellation requests may not be accepted. Please contact our support team for assistance.",
    },
    {
      icon: <FaUndo />,
      title: "Returns & Refunds",
      content:
        "Eligible returns and refunds are processed according to our Refund Policy. Products must satisfy applicable return conditions before refunds are approved.",
    },
    {
      icon: <FaShieldAlt />,
      title: "Privacy & Security",
      content:
        "Your personal information is collected and processed in accordance with our Privacy Policy. We implement appropriate security measures to protect customer data and transactions.",
    },
    {
      icon: <FaBalanceScale />,
      title: "Governing Law",
      content:
        "These Terms & Conditions shall be governed by the laws of India. Any disputes shall be subject to the jurisdiction of the competent courts where the company is registered.",
    },
    {
      icon: <FaPhoneAlt />,
      title: "Contact Us",
      content:
        "For any questions regarding these Terms & Conditions, customers can reach our support team through the contact details available on the Contact Us page.",
    },
  ];

  return (
    <div
      style={{
        background: "#f5f7fb",
        minHeight: "100vh",
        padding: "60px 0",
      }}
    >
      <div className="container">

        {/* Hero Section */}
        <div
          className="text-center text-white p-5 mb-5 rounded-4 shadow"
          style={{
            background:
              "linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)",
          }}
        >
          <h1 className="display-4 fw-bold mb-3">
            Terms & Conditions
          </h1>

          <p className="lead mb-0">
            Please read these terms carefully before using our website or
            placing an order with Glamira.
          </p>
        </div>

        {/* Intro */}
        <div className="card border-0 shadow-sm rounded-4 mb-5">
          <div className="card-body p-4">
            <h3 className="fw-bold mb-3">
              Welcome to Glamira
            </h3>

            <p className="text-muted mb-0">
              These Terms & Conditions govern your access to and use of
              Glamira's eCommerce platform. By browsing, creating an account,
              or placing an order, you acknowledge that you have read,
              understood, and agreed to these terms.
            </p>
          </div>
        </div>

        {/* Dynamic Cards */}
        <div className="row">
          {sections.map((item, index) => (
            <div className="col-lg-6 mb-4" key={index}>
              <div
                className="card border-0 shadow-sm h-100 rounded-4"
                style={{
                  transition: "0.3s",
                }}
              >
                <div className="card-body p-4">

                  <div className="d-flex align-items-center mb-3">

                    <div
                      className="me-3 d-flex align-items-center justify-content-center rounded-circle text-white"
                      style={{
                        width: 55,
                        height: 55,
                        background:
                          "linear-gradient(135deg,#2563eb,#1d4ed8)",
                        fontSize: 22,
                      }}
                    >
                      {item.icon}
                    </div>

                    <div>
                      <small className="text-primary fw-bold">
                        Section {index + 1}
                      </small>
                      <h5 className="fw-bold mb-0">
                        {item.title}
                      </h5>
                    </div>
                  </div>

                  {item.content && (
                    <p className="text-muted mb-0">
                      {item.content}
                    </p>
                  )}

                  {item.list && (
                    <ul className="text-muted ps-3 mb-0">
                      {item.list.map((listItem, i) => (
                        <li key={i} className="mb-2">
                          {listItem}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Important Notice */}

        <div
          className="p-4 rounded-4 mt-4 shadow-sm"
          style={{
            background: "#fff8e1",
            borderLeft: "6px solid #f59e0b",
          }}
        >
          <h4 className="fw-bold mb-3">
            ⚠️ Important Notice
          </h4>

          <p className="mb-0 text-muted">
            Glamira reserves the right to update or modify these Terms &
            Conditions at any time without prior notice. Continued use of the
            website following any changes constitutes acceptance of the revised
            terms.
          </p>
        </div>

        {/* Contact CTA */}

        <div className="card border-0 shadow-lg rounded-4 mt-5">
          <div className="card-body text-center p-5">

            <h2 className="fw-bold mb-3">
              Have Questions?
            </h2>

            <p className="text-muted mx-auto" style={{ maxWidth: 700 }}>
              Our customer support team is always available to assist you with
              any questions related to our Terms & Conditions, orders,
              payments, or policies.
            </p>

            <a href="/contact" className="btn btn-primary btn-lg px-5 mt-3">
              Contact Support
            </a>

          </div>
        </div>

        {/* Footer */}

        <div className="text-center mt-5 pt-4 border-top">

          <h5 className="fw-bold">
            Thank You for Shopping with Glamira
          </h5>

          <p className="text-muted mb-2">
            We are committed to providing a secure, transparent, and
            customer-focused shopping experience.
          </p>

          <small className="text-secondary">
            © {new Date().getFullYear()} Glamira. All Rights Reserved.
          </small>

        </div>
      </div>
    </div>
  );
};

export default TermsConditions;